import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebLordGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {

    if (environment.deviceApp || HttpHelpers.getSubdomain()) {
      return this.router.parseUrl('/home');
      //return this.router.navigateByUrl('/home', { replaceUrl: true });
    }
      

    return true;
  }
}
